import { ThemeColors } from '~/themes/colors'

export interface LoginPromptColors {
  Background: ThemeColors
  ApiEnvironmentToggle: {
    Background: ThemeColors
    TitleFontColor: ThemeColors
  }
}

export const loginPromptColors: LoginPromptColors = {
  Background: {
    default: 'white',
  },
  ApiEnvironmentToggle: {
    Background: {
      default: 'blue.200',
    },
    TitleFontColor: {
      default: 'white',
    },
  },
}
